// extracted by mini-css-extract-plugin
export default {"container":"br-z","heading":"cr-z","text":"dr-z","info":"er-z","link":"fr-z","fullMaxWidth":"gr-z"};